import { EventItem, TagItem } from './../models/Item';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DbmanagerService } from '../services/dbmanager.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {

  public UID = '';
  public eventHistory: Array<EventItem>;
  public tagHistory: Array<TagItem>;
  public sortedHistory: Array<object>;

  constructor(private dbservice: DbmanagerService, private route: ActivatedRoute) {
    this.eventHistory = new Array<EventItem>();
    this.tagHistory = new Array<TagItem>();
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe( params => {
      this.UID = params.UID;
    });
    this.sortedHistory = new Array<object>();
    this.dbservice.getHistory(this.UID);

    this.dbservice.getEventHistory().subscribe(eventHistory => {
      this.eventHistory = eventHistory;
    });

    this.dbservice.getTagHistory().subscribe(tagHistory => {
      this.tagHistory = tagHistory;
      this.sortedHistory = this.eventHistory.concat(tagHistory);
      this.sortedHistory.push(this.dbservice.tagItems.get(this.UID));
      this.sortedHistory.push(this.dbservice.eventItems.get(this.UID));
      this.sortedHistory.sort((a, b) => {
        let adate;
        if ('EVENT_DATETIME' in a) {
          adate = (a as EventItem).EVENT_DATETIME ;
        } else {
          adate = (a as TagItem).EDIT_DATETIME ;
        }

        let bdate;
        if ('EVENT_DATETIME' in b) {
          bdate = (b as EventItem).EVENT_DATETIME ;
        } else {
          bdate = (b as TagItem).EDIT_DATETIME ;
        }

        if (adate < bdate) {
            return 1;
        }
        if (adate > bdate) {
            return -1;
        }
        return 0;
      });
    });
  }

  getUserName(item): string {
    let user;
    if ('EVENT_DATETIME' in item) {
      user = (item as EventItem).USER_ID ;
    } else {
      user = (item as TagItem).USER_ID ;
    }
    return this.dbservice.users.get(user).NAME;
  }

  getDate(item): string {
    let dateObj;
    if ('EVENT_DATETIME' in item) {
      dateObj = (item as EventItem).EVENT_DATETIME;
    } else {
      dateObj = (item as TagItem).EDIT_DATETIME ;
    }
    try {
      dateObj =  new DatePipe('PL').transform(dateObj.toDate(), 'medium');
    } catch {
      dateObj = '';
    }

    return dateObj;
  }

  getUserSurname(item): string {
    let user;
    if ('EVENT_DATETIME' in item) {
      user = (item as EventItem).USER_ID ;
    } else {
      user = (item as TagItem).USER_ID ;
    }
    return this.dbservice.users.get(user).SURNAME;
  }

  getHistoryFields(index, header: boolean): string[] {
    let fields = new Array<string>();
    let i = index;
    if (header) {
      fields.push($localize`:@@history.Date:Date`);
      fields.push($localize`:@@history.Name:Imię`);
      fields.push($localize`:@@history.Surname:Nazwisko`);
    } else {
      fields.push(this.getDate(this.sortedHistory[index]));
      fields.push(this.getUserName(this.sortedHistory[index]));
      fields.push(this.getUserSurname(this.sortedHistory[index]));
    }


    while (i < this.sortedHistory.length) {
      i++;
      if (i === this.sortedHistory.length) {
        if ('EVENT_DATETIME' in this.sortedHistory[index]) {
          fields = fields.concat(this.getEventHistoryData((this.sortedHistory[index] as EventItem), undefined, header)) ;
        } else {
          fields = fields.concat(this.getTagHistoryData((this.sortedHistory[index] as TagItem), undefined, header)) ;
        }
        return fields;
      } else {
        if ((('EVENT_DATETIME' in this.sortedHistory[i]) && ('EVENT_DATETIME' in this.sortedHistory[index])) ||
            (('EDIT_DATETIME' in this.sortedHistory[i]) && ('EDIT_DATETIME' in this.sortedHistory[index]))) {

          if ('EVENT_DATETIME' in this.sortedHistory[i]) {
            const obj1 = (this.sortedHistory[index] as EventItem) ;
            const obj2 = (this.sortedHistory[i] as EventItem) ;
            fields = fields.concat(this.getEventHistoryData(obj1, obj2, header)) ;
          } else {
            const obj1 = (this.sortedHistory[index] as TagItem) ;
            const obj2 = (this.sortedHistory[i] as TagItem) ;
            fields = fields.concat(this.getTagHistoryData(obj1, obj2, header)) ;
          }
          return fields;
        }
      }
    }
    return fields;
  }

  getEventHistoryData(obj1: EventItem, obj2: EventItem, header: boolean): string[] {
    const fields  = new Array<string>();
    if (obj2 === undefined) {
      if ((obj1.LOCATION !== undefined) && (obj1.LOCATION.length > 0)) {
        fields.push( header ? $localize`:@@history.Location:Lokalizacja` : obj1.LOCATION );
      }
      if (obj1.COORD !== undefined) {
        fields.push( header ? $localize`:@@history.Position:Pozycja` : $localize`:@@history.Added:dodano`);
      }
      if ((obj1.STATE !== undefined) && (obj1.STATE.length > 0)) {
        fields.push( header ? $localize`:@@history.State:Stan` : obj1.STATE );
      }
      if ((obj1.REMARKS !== undefined) && (obj1.REMARKS.length > 0)) {
        fields.push( header ? $localize`:@@history.Remarks:Uwagi` : obj1.REMARKS );
      }
      if ((obj1.PHOTOS !== undefined) &&
         ((obj1.PHOTOS[0] !== undefined) || (obj1.PHOTOS[1] !== undefined) || (obj1.PHOTOS[2] !== undefined)) &&
         ((obj1.PHOTOS[0].length > 0) || (obj1.PHOTOS[1].length > 0) || (obj1.PHOTOS[2].length > 0))) {
        fields.push( header ? $localize`:@@history.Photos:Zdjęcia` : $localize`:@@history.Added:dodano` );
      }
    } else {
      if (obj1.LOCATION != obj2.LOCATION) {
        fields.push( header ? $localize`:@@history.Location:Lokalizacja` :
        '<s>' +
        ((obj2.LOCATION === undefined) ? '' : obj2.LOCATION) +
        '</s>' + ' ' +
        ((obj1.LOCATION === undefined) ? '' : obj1.LOCATION));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (((obj1.COORD !== undefined) && (obj2.COORD !== undefined) &&
           (obj1.COORD['A0'] !== undefined) && (obj2.COORD['A0'] !== undefined)) &&
          ((obj1.COORD['A0'].X !== obj2.COORD['A0'].X) || (obj1.COORD['A0'].Y !== obj2.COORD['A0'].Y))) {
        fields.push( header ? $localize`:@@history.Position:Pozycja` : $localize`:@@history.Changed:zmieniono`);
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      } else if ((obj1.COORD !== undefined) && (obj2.COORD === undefined)) {
        fields.push( header ? $localize`:@@history.Position:Pozycja` : $localize`:@@history.Added:dodano`);
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.STATE != obj2.STATE) {
        fields.push( header ? $localize`:@@history.State:Stan` :
        '<s>' +
        ((obj2.STATE === undefined) ? '' : obj2.STATE) +
        '</s>' + ' ' +
        ((obj1.STATE === undefined) ? '' : obj1.STATE));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.REMARKS !== obj2.REMARKS) {
        fields.push( header ? $localize`:@@history.Remarks:Uwagi` :
        '<s>' +
        ((obj2.REMARKS === undefined) ? '' : obj2.REMARKS) +
        '</s>' + ' ' +
        ((obj1.REMARKS === undefined) ? '' : obj1.REMARKS));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.PHOTOS === undefined) { obj1.PHOTOS = new Map<string, string>(); }
      if (obj2.PHOTOS === undefined) { obj2.PHOTOS = new Map<string, string>(); }
      const photos: string = this.comparePhotos(new Map<string, string>(Object.entries(obj1.PHOTOS)),
                                                new Map<string, string>(Object.entries(obj2.PHOTOS)));
      if (photos.length > 0) {
        fields.push( header ? $localize`:@@history.Photos:Zdjęcia` : photos);
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
    }
    return fields;
  }

  comparePhotos(photos1: Map<string, string>, photos2: Map<string, string>) {
    const p1 = new Map([['0', ''], ['1', ''], ['2', '']]);
    const p2 = new Map([['0', ''], ['1', ''], ['2', '']]);
    let photos = '';
    if (photos1 !== undefined) {
      photos1.forEach((value, key) => {
       if ((value !== undefined) && (value.length > 0)) {
         p1.set(key, value);
       }
      });
    }

    if (photos2 !== undefined) {
      photos2.forEach((value, key) => {
       if ((value !== undefined) && (value.length > 0)) {
         p2.set(key, value);
       }
      });
    }
    p1.forEach((value, key) => {
      if (value !== p2.get(key)) {
        photos += (value.length === 0) ? '<s>' + key + '</s>' : key + ' ';
      }
     });
    return photos;
  }

  compareLinkedFileds(fields1: Array<string>, fields2: Array<string>) {

    let photos = '';
    if (fields1 === undefined) { fields1 = new Array<string>(); }
    if (fields2 === undefined) { fields2 = new Array<string>(); }

    fields1.forEach(tag => {
       if (tag.length > 0) {
         if (!fields2.includes(tag)) {
          photos += tag + ' ';
         }
       }
      });

    fields2.forEach(tag => {
      if (tag.length > 0) {
        if (!fields1.includes(tag)) {
         photos +=  '<s>' + tag + '</s>' + ' ';
        }
      }
     });

    return photos;
  }

  getTagHistoryData(obj1: TagItem, obj2: TagItem, header: boolean): string[] {
    const fields  = new Array<string>();
    if (obj2 === undefined) {
      if ((obj1.DESCRIPTION !== undefined) && (obj1.DESCRIPTION.length > 0)) {
        fields.push( header ? $localize`:@@history.Description:Opis` : obj1.DESCRIPTION);
      }
      if ((obj1.TITLE !== undefined) && (obj1.TITLE.length > 0)) {
        fields.push( header ? $localize`:@@history.Description:Opis` : obj1.TITLE);
      }
      if ((obj1.PHOTO !== undefined)  && (obj1.PHOTO.length > 0)) {
        fields.push( header ? $localize`:@@history.Miniature:Miniatura` : (obj1.PHOTO.length > 0 ) ?
                      $localize`:@@history.Changed:zmieniono` :
                      $localize`:@@history.Removed:usunięto`);
      }

      if ((obj1.MARK !== undefined) && (obj1.MARK.length > 0)) {
        fields.push( header ? $localize`:@@history.Mark:Marka` : obj1.MARK);
      }
      if ((obj1.PURCHASE_DATE !== undefined) && (obj1.PURCHASE_DATE.toString().length > 0)) {
        fields.push( header ? $localize`:@@history.PurchaseDate:Data Zakupu` :
                     new DatePipe('PL').transform((obj1.PURCHASE_DATE as any).toDate(), 'medium'));
      }
      if ((obj1.CATEGORY !== undefined) && (obj1.CATEGORY.length > 0)) {
        fields.push( header ? $localize`:@@history.Category:Kategoria` : obj1.CATEGORY);
      }
      if ((obj1.SIZE !== undefined) && (obj1.SIZE.length > 0)) {
        fields.push( header ? $localize`:@@history.Size:Rozmiar` : obj1.SIZE);
      }
      if ((obj1.LINK !== undefined) && (obj1.LINK.length > 0)) {
        fields.push( header ? $localize`:@@history.Link:Link` : obj1.LINK);
      }
      if ((obj1.REG_NUM !== undefined) && (obj1.REG_NUM.length > 0)) {
        fields.push( header ? $localize`:@@history.Evid:Numer Ewidencyjny` : obj1.REG_NUM);
      }
      const linkedFields: string = this.compareLinkedFileds(obj1.LINKED_FIELDS, undefined);
      if (linkedFields.length > 0) {
        fields.push( header ? $localize`:@@history.LinkedFields:Produkty powiązane` : linkedFields);
      }

    } else {
      if (obj1.DESCRIPTION !== obj2.DESCRIPTION) {
        fields.push( header ? $localize`:@@history.Description:Opis` :
        '<s>' +
        ((obj2.DESCRIPTION === undefined) ? '' : obj2.DESCRIPTION) +
        '</s>' + ' ' +
        ((obj1.DESCRIPTION === undefined) ? '' : obj1.DESCRIPTION));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.TITLE !== obj2.TITLE) {
        fields.push( header ? $localize`:@@history.Title:Tytuł` :
        '<s>' +
        ((obj2.TITLE === undefined) ? '' : obj2.TITLE) +
        '</s>' + ' ' +
        ((obj1.TITLE === undefined) ? '' : obj1.TITLE));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if ((obj1.PHOTO !== undefined) && (obj1.PHOTO !== obj2.PHOTO)) {

        fields.push( header ? $localize`:@@history.Miniature:Miniatura` :
        ((obj1.PHOTO.length > 0 ) ? ( ((obj2.PHOTO !== undefined) && (obj2.PHOTO.length > 0)) ? $localize`:@@history.Changed:zmieniono` :
                                                            $localize`:@@history.Added:dodano`)  :
                                                            $localize`:@@history.Removed:usunięto`)) ;
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.MARK !== obj2.MARK) {
        fields.push( header ? $localize`:@@history.Mark:Marka` :
        '<s>' +
        ((obj2.MARK === undefined) ? '' : obj2.MARK) +
        '</s>' + ' ' +
        ((obj1.MARK === undefined) ? '' : obj1.MARK));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if ((obj1.PURCHASE_DATE.toString() !== obj2.PURCHASE_DATE.toString()) &&
                                         (obj1.PURCHASE_DATE !== undefined) &&
                                         (obj2.PURCHASE_DATE !== undefined)) {
        fields.push( header ? $localize`:@@history.PurchaseDate:Data Zakupu` :
        '<s>' +
        ((obj2.PURCHASE_DATE === undefined) ? '' : new DatePipe('PL').transform((obj2.PURCHASE_DATE as any).toDate(), 'medium')) +
        '</s>' + ' ' +
        ((obj1.PURCHASE_DATE === undefined) ? '' : new DatePipe('PL').transform((obj1.PURCHASE_DATE as any).toDate(), 'medium')));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.CATEGORY !== obj2.CATEGORY) {
        fields.push( header ? $localize`:@@history.Category:Kategoria` :
        '<s>' +
        ((obj2.CATEGORY === undefined) ? '' : obj2.CATEGORY) +
        '</s>' + ' ' +
        ((obj1.CATEGORY === undefined) ? '' : obj1.CATEGORY));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.SIZE !== obj2.SIZE) {
        fields.push( header ? $localize`:@@history.Size:Rozmiar` :
        '<s>' +
        ((obj2.SIZE === undefined) ? '' : obj2.SIZE) +
        '</s>' + ' ' +
        ((obj1.SIZE === undefined) ? '' : obj1.SIZE));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.LINK !== obj2.LINK) {
        fields.push( header ? $localize`:@@history.Link:Link` :
        '<s>' +
        ((obj2.LINK === undefined) ? '' : obj2.LINK) +
        '</s>' + ' ' +
        ((obj1.LINK === undefined) ? '' : obj1.LINK));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      if (obj1.REG_NUM !== obj2.REG_NUM) {
        fields.push( header ? $localize`:@@history.Evid:Numer Ewidencyjny` :
        '<s>' +
        ((obj2.REG_NUM === undefined) ? '' : obj2.REG_NUM) +
        '</s>' + ' ' +
        ((obj1.REG_NUM === undefined) ? '' : obj1.REG_NUM));
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
      const linkedFields: string = this.compareLinkedFileds(obj1.LINKED_FIELDS, obj2.LINKED_FIELDS);
      if (linkedFields.length > 0) {
        fields.push( header ? $localize`:@@history.LinkedFields:Produkty powiązane` : linkedFields);
        if (fields[fields.length - 1 ].length <= 1) {
          fields.pop();
        }
      }
    }
    return fields;
  }

  getHistoryData(index): string[] {
    return new Array<string>();
  }

}
